import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { useGlobalTextStyles, useModal, userInfo, userType } from 'utils';
import { agentActions, officeActions, reportServices } from 'store';
import { ErrMessage, MinLoader, modalsStyle, MultipleCheckBox, SelectType } from 'components';
import { loadsStyle } from '../../../pages/loads/styles';

export const PayrollCsv = ({}) => {
  const {
    officesList,
    officeBranchesList,
    branchAgentsList,
    agentList,
    branchesList,
    byList,
  } = useSelector((state) => ({
    officesList: state.offices.officesList,
    officeBranchesList: state.offices.officeBranchesList,
    branchAgentsList: state.agents.branchAgentsList,
    agentList: state.agents.agentList,
    branchesList: state.branches.branchesList,
    byList: state.agents.byList,
  }));
  const classes = modalsStyle();
  const customClass = loadsStyle();
  const globalText = useGlobalTextStyles();
  const dispatch = useDispatch();
  const [inputs, setInputs] = useState({
    types: [
      { name: 'Gross Profit', id: 'GROSSPROFIT' },
    ],
  });
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState('');
  const checkBranchAndOfficeManager = userType === 'ADMIN' && userInfo?.managedOffices?.length > 0 ? false : userInfo?.managedBranches?.length > 0 ? false : true;
  const { close } = useModal();

  const handleChange = (ev, name) => {
    const id = ev?.target?.value;
    const anotherInfo = {
      ...inputs,
    };

    if (name === 'office') {
      if (id) {
        dispatch(officeActions.getOfficeBranches(id));
        dispatch(agentActions.getBy(id));
        anotherInfo.office = id;
      } else {
        dispatch(officeActions.removeOfficeBranches());
        delete anotherInfo.office;
        delete anotherInfo.branch;
        delete anotherInfo.agent;
      }
    }
    if (name === 'branch') {
      if (id) {
        dispatch(agentActions.getAgentByBranch(id));
        anotherInfo.branch = id;
      } else {
        dispatch(agentActions.removeAgentByBranch());
        delete anotherInfo.branch;
        delete anotherInfo.agent;
      }
    }

    if (name === 'agent') {
      if (id) {
        anotherInfo.agent = id;
      } else {
        delete anotherInfo.agent;
      }
    }
    setInputs(anotherInfo);
  };

  const handleSelect = (e) => {
    setInputs(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
    setError('');
  };

  useEffect(() => {
    if (userInfo?.managedBranches?.length > 0) {
      dispatch(officeActions.getOfficeBranches(userInfo?.office?.id));
    }
  }, []);


  const handleExport = async () => {
    if (inputs?.date) {
      setLoader(true);
      try {
        const date = {
          ...inputs,
        };

        if (inputs?.types?.length) {
          date.types = inputs?.types?.map((i) => i.id);
        }
        if (inputs?.date) {
          date.month = moment(inputs?.date).format('MM');
          date.year = moment(inputs?.date).format('YYYY');
          delete date.date;
        }
        const response = await reportServices.getPayrollCsvReport(date);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `payroll.csv`);
        document.body.appendChild(link);
        link.click();
        setLoader(false);
        close();
      } catch (err) {
        if (err?.data?.message === 'Load was not found') {
          setError('Load was not found');
        }
        setLoader(false);
      }
    } else {
      setError('date');
    }
  };

  return (
    <div className={classes.loadCsvModal}>
      <div>
        <p className={globalText.modalTitle}>{'Export Date Range'}</p>
        <p className={globalText.modalText}>
          {'All data within the selected date range.'}
        </p>
        <div>
          {checkBranchAndOfficeManager &&
            <SelectType
              title={'Office'}
              name={'office'}
              handleSelect={(option) => handleChange(option, 'office')}
              defaultValue={inputs.office}
              list={officesList?.offices || []}
              renderValue={(i) => i?.name}
            />
          }
          <SelectType
            title={'Branch'}
            name={'branch'}
            handleSelect={(option) => handleChange(option, 'branch')}
            defaultValue={inputs.branch}
            // list={inputs?.office ? officeBranchesList?.branches && officeBranchesList?.branches :
            //   branchesList?.branches ? branchesList?.branches :
            //     []
            // }
            list={
              inputs?.office
                ? officeBranchesList?.branches || []
                : branchesList?.branches || []
            }
            renderValue={(i) => i?.name}
          />
          <SelectType
            title={'Agent'}
            name={'agent'}
            handleSelect={(option) => handleChange(option, 'agent')}
            defaultValue={inputs.agent}
            list={inputs?.office && !inputs?.branch ? byList :
              inputs?.branch ? branchAgentsList :
                agentList?.agents ? agentList.agents : []
            }
            renderValue={(i) => `${i?.firstName}${i?.lastName}`}
          />
          <MultipleCheckBox
            stylesWrapper={{ width: '100%' }}
            handleChange={(value) => setInputs(prevState => ({ ...prevState, ['types']: value }))}
            name="types"
            renderValue={(item) => item?.name}
            value={inputs?.types || []}
            permissionsList={[
              { name: 'Credit', id: 'CREDIT' },
              { name: 'Charge', id: 'CHARGE' },
              { name: 'Gross Profit', id: 'GROSSPROFIT' },
              { name: 'Service Fee', id: 'SERVICEFEE' },
              { name: 'Other Fees', id: 'OTHERFEES' },
              { name: 'lpf', id: 'LPF' },
              { name: 'Software Fee', id: 'SOFTWAREFEE' },
              { name: 'Office Expense', id: 'OFFICE_EXPENSE' },
              { name: 'Load Count', id: 'LOAD_COUNT' },
              { name: 'Flat Fee', id: 'FLAT_FEE' },
              // { name: 'Other', id: 'OTHER' },
            ]}
            label={'Types*'}
            typeError={error === 'types'}
          />
          <input
            name={'date'}
            style={error === 'date' ? { borderColor: '#F07379' } : {}}
            onChange={handleSelect}
            className={customClass.exportCsvDate}
            type={'month'}
          />
          <ErrMessage
            text={error === 'date' ? 'Date is required' : ''}
            style={{ position: 'relative' }}
          />
        </div>
        <div className={customClass.customClassWrapper} style={{ marginTop: 24 }}>
          <button onClick={handleExport} className={customClass.exportButton}>
            {loader ?
              <MinLoader position={'relative'} color={'white'} />
              :
              'Export CSV'
            }
          </button>
        </div>
      </div>
    </div>
  );
};